var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeviceString(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v160h-80v-40H280v480h400v-40h80v160q0 33-23.5 56.5T680-40H280Zm0-120v40h400v-40H280Zm400-160-6-50q-8-3-14-6.5t-12-9.5l-46 20-40-70 40-30q-2-8-2-15t2-15l-40-30 42-68 44 18q6-5 12-8t14-6l6-50h80l6 50q8 3 14 6t12 8l44-18 42 68-40 30q2 8 2 15t-2 15l40 30-40 70-46-20q-6 6-12 9.5t-14 6.5l-6 50h-80Zm40-100q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17ZM280-800h400v-40H280v40Zm0 0v-40 40Zm0 640v40-40Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceString);
export default __webpack_public_path__ + "static/media/iconDeviceString.08ff1aa1.svg";
export { ForwardRef as ReactComponent };